import { Modal } from 'peach/components'
import { useParams } from 'peach/router'

import { useInternalLoanScheduleDefer } from 'core/types'

import DeferScheduleForm from './DeferScheduleForm'

const DeferScheduleModal = ({ onSuccess }: any = {}) => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const { mutateAsync: deferSchedule } = useInternalLoanScheduleDefer({
    companyId,
    personId,
    loanId,
  })

  const initialValue = {
    bufferToPushOutSchedule: 0,
    waiveFee: false,
  }
  return (
    <Modal
      initialValue={initialValue}
      onSubmit={async (options) => {
        await deferSchedule(options)
        if (onSuccess) onSuccess()
      }}
      render={({ value }) => (
        <DeferScheduleForm loanId={loanId} personId={personId} value={value} />
      )}
      tabs
      title='Defer Schedule'
    />
  )
}

export default DeferScheduleModal
